export const RENTER_APP_ID = '1449873080';
export const OWNER_APP_ID = '1369215908';

export const getItunesAppUniversalLinkMetaTag = (url: string, appId: string) => (
  <meta name="apple-itunes-app" content={`app-id=${appId}, app-argument=${url}`} />
);
